import React from "react"; // eslint-disable-line no-unused-vars
import { addNotification as notify } from "reapop";
import { validateField, submitForm } from "../../pages/functions";
import { connect } from "react-redux";
import Widget from "../../elements/Widget";
import RequestorInformation from "./RequestorInformation";
import StaticConfig from "../StaticConfig";
import HeroImage from "../HeroImage";
import {
  ABBVIE_EMPLOYEE,
  HCP,
  PATIENT,
  REF_DATA,
  COUNTRIES,
  ADDRESS_FIELD_NAMES,
} from "../../constants";
import PatientDeliveryMethod from "./PatientDeliveryMethod";
import RequestInformation from "./RequestInformation";
import CertifyDocuments from "./CertifyDocuments";
import CountryAwareComponent from "../CountryAwareComponent";
import "../../css/forms/default-forms.css";
import {
  referenceData,
  selectedCountry,
  listOfCountries,
  reset,
} from "../../actions/referenceData";
import { setPermissionAction } from "../../actions/config";
import { bindActionCreators } from "redux";
import { formFieldsPerLanguage } from "../language/FormFieldsPerLanguage";
import { buildGmisRequest } from "./BuildGmisRequest";
import { api } from "../index.api";
import { SubmitInquiryLoading } from "./SubmitInquiryLoading";
import {
  defaultFields,
  fieldConfiguration,
} from "./FlowTypeFieldConfiguration";
import { initializeReferenceData } from "../../helpers/InitializeStoreData";
import { switchLanguage } from "../language/actions";
import "url-search-params-polyfill";
import sha256 from "crypto-js/sha256";
import imgHeaderSubmitInquiryMobile from "./assets/img_header_submit_inquiry_mobile.jpg";
import imgHeaderSubmitInquiry from "./assets/img_header_submit_inquiry.jpg";
import { getCookie } from "../../helpers/CookieHandler";
import { getApplicationSiteKey, getApplicationRegex } from "../plugins/utils";

require("formdata-polyfill");
class SubmitInquiry extends CountryAwareComponent {
  constructor(props) {
    super(props);
    this.componentName = "SubmitInquiry";
    this._uploadedFiles = this._uploadedFiles.bind(this);

    const fields = defaultFields;

    this.onToggle = this.onToggle.bind(this);
    this.state = {
      loading: false,
      fields,
      apiCallfinished: true,
      userCatagory: null,
      callbackUrl: null,
      initialLoad: true,
      documents: [],
      cart: [],
      showDocs: false,
      docsLoading: false,
      maintMsg: false,
    };
    this._updateFieldConfigurations(props.flowType, props.referenceData);
    formFieldsPerLanguage(this.state.fields, this.props.pageContent.content);
    this.listOfCountries = [];
    this.formData = {};

    this.responseOptions = [
      {
        value: 2,
        label: "2 days",
      },
      {
        value: 5,
        label: "5 days",
      },
      {
        value: 7,
        label: "7 days",
      },
      {
        value: 15,
        label: "15 days",
      },
    ];
    this._responseWithinDropDownOptionsAsPerLanguage(
      this.props.pageContent.content
    );
    this.medicalSpecialities = [];
    this.indicatorOptions = [];
    this.requestorTypes = [];
    this.products = [];
    this.deliveryMethods = [];
    this.conferenceOptions = [];
    this.salutation = [];
    this.countryFlip = false;
    this._validate = this._validate.bind(this);
    this._submit = this._submit.bind(this);
    this._reset = this._reset.bind(this);
    this._setConferenceParams(this.state.fields);

    this._setRouterFormState(
      props.location,
      props.referenceData,
      this.state.fields
    );
  }

  componentDidMount() {
    // display kiosk functionality in scibooth
    if (this.props.flowType === "SCIBOOTH") {
      api.getKioskCongresses((response) => {
        response.forEach((conference) => {
          const option = {
            value: conference.shortName,
            label: conference.shortName,
            conference,
          };
          // TODO set state instead maybe?
          this.conferenceOptions.push(option);
        });
      });
    }
  }

  componentWillMount() {
    this._setStateVariables(this.props);
  }

  checkIfRespondedWithRequired = (fields, cart) => {
    fields.respondedWith.rules.required.required =
      !fields.followup.value && cart.length === 0;
    fields.respondedWith.rules.ignoreNull =
      !fields.respondedWith.rules.required.required;
    if (!fields.respondedWith.rules.required.required) {
      fields.respondedWith.errors = [];
    }
  };

  handleCart = (id) => {
    let { fields, cart } = this.state;
    if (cart.includes(id)) {
      cart = cart.filter((val) => {
        return id !== val;
      });
    } else {
      cart = [...cart, id];
    }
    this.checkIfRespondedWithRequired(fields, cart);
    this.setState({ fields, cart });
  };

  handleAttachDocsRadio = (event) => {
    const { fields } = this.state;
    this.setState({ showDocs: event.target.value === "true" });
    if (event.target.value === "false") {
      this.checkIfRespondedWithRequired(fields, []);
      this.setState({ fields, cart: [] });
    }
  };

  handleConferenceChange = (congress) => {
    // get documents and set conference
    const { fields } = this.state;
    this.checkIfRespondedWithRequired(fields, []);
    this.setState({ fields, showDocs: false, docsLoading: true, cart: [] });
    api.getKioskDocuments(
      { congress },
      (documents) => {
        documents.forEach((document) => {
          document.products.sort();
          document.categories.sort();
        });
        this.setState({ documents, docsLoading: false });
      },
      () => {
        // on failure, setting documents to empty array
        // this will show "No documents were found" to the user
        this.setState({ documents: [], docsLoading: false });
      }
    );
  };

  _updateFieldConfigurations = (flowType, referenceData) => {
    const fields = this.state.fields;
    this._updateFieldConfigurationForFlowType(flowType, fields);
    this._updateFieldConfigurationForCountry(fields);
    const userType = referenceData ? referenceData.referenceData.UserType : "";
    this._updateFieldConfigurationForUserType(flowType, userType, fields);
  };

  _updateFieldConfigurationForFlowType = (flowType, fields) => {
    const fieldConfigurationForSelectedFlowType = fieldConfiguration[flowType];
    fieldConfigurationForSelectedFlowType.forEach((element) => {
      const field = fields[element.name];
      if (field) {
        if (field.rules.required && typeof field.rules.required !== "boolean") {
          field.rules.required.required = element.required;
        } else {
          field.rules.required = element.required;
        }
        field.display = element.display;
        field.rules.ignoreNull = !element.required;
        field.placeholder = element.placeholder;
        field.disabled = element.disabled;
      }
    });
  };

  _updateFieldConfigurationForUserType = (flowType, userType, fields) => {
    if (flowType === "MI_PORTAL_REQUEST" && userType === PATIENT) {
      fields.title.display = false;
      fields.title.rules.required.required = false;
      fields.title.rules.ignoreNull = true;
      fields.hcpLicenseNumber.display = false;
      fields.hcpLicenseNumber.rules.required.required = false;
      fields.hcpLicenseNumber.rules.ignoreNull = true;
      fields.affiliation.display = false;
      fields.affiliation.rules.required.required = false;
      fields.affiliation.rules.ignoreNull = true;
      fields.medicalSpeciality.display = false;
      fields.medicalSpeciality.rules.required.required = false;
      fields.medicalSpeciality.rules.ignoreNull = true;
      fields.responseDeadline.display = false;
      fields.responseDeadline.rules.required.required = false;
      fields.responseDeadline.rules.ignoreNull = true;
      fields.agree.display = false;
      fields.agree.rules.required.required = false;
      fields.agree.rules.ignoreNull = true;

      // Patients use a different version of this field, see PatientDeliveryMethod.js
      fields.deliveryMethod.display = false;

      this._togglePatientAddressFields(
        fields.deliveryMethod.value === "Mail",
        fields
      );
      this._togglePatientPhoneFields(
        fields.deliveryMethod.value === "Phone",
        fields
      );
    }
  };

  _togglePatientAddressFields = (on, { street, city, state }) => {
    street.value = "";
    street.errors = null;
    street.display = on;
    street.rules.required.required = on;
    street.rules.ignoreNull = !on;
    city.value = "";
    city.errors = null;
    city.display = on;
    city.rules.required.required = on;
    city.rules.ignoreNull = !on;
    state.value = "";
    state.errors = null;
    state.display = on;
    state.rules.required.required = on;
    state.rules.ignoreNull = !on;
  };

  _togglePatientPhoneFields = (on, { phone, extn }) => {
    phone.value = "";
    phone.errors = null;
    phone.display = on;
    phone.rules.required.required = on;
    phone.rules.ignoreNull = !on;
    extn.value = "";
    extn.errors = null;
    extn.display = on;
    extn.rules.required.required = false;
    extn.rules.ignoreNull = true;
  };

  _updateFieldsBasedOnDeliveryType = (value) => {
    const { fields } = this.state;

    if (value === "Phone") {
      fields.phone.rules.ignoreNull = false;
      fields.phone.rules.required.required = true;
    } else {
      fields.phone.rules.ignoreNull = true;
      fields.phone.rules.required.required = false;
    }

    if (!StaticConfig.Context.ComponentConfig.addressMandatory) {
      if (value === "Mail") {
        ADDRESS_FIELD_NAMES.forEach((fieldName) => {
          fields[fieldName].rules.required.required = true;
          fields[fieldName].rules.ignoreNull = false;
        });
      } else {
        ADDRESS_FIELD_NAMES.forEach((fieldName) => {
          fields[fieldName].rules.required.required = false;
          fields[fieldName].rules.ignoreNull = true;
        });
      }
    }
    this.setState({ fields });
  };

  _updatePatientFieldsBasedOnDeliveryType = (value) => {
    const { fields } = this.state;
    this._togglePatientAddressFields(value === "Mail", fields);
    this._togglePatientPhoneFields(value === "Phone", fields);
    this.setState({ fields });
  };

  componentWillReceiveProps(nextProps) {
    const languageContent = nextProps.pageContent.content;
    this._updateFieldConfigurations(
      nextProps.flowType,
      nextProps.referenceData
    );
    this._setStateVariables(nextProps);
    if (nextProps.flowType === "MI_PORTAL_REQUEST") {
      formFieldsPerLanguage(this.state.fields, languageContent);
      this._responseWithinDropDownOptionsAsPerLanguage(languageContent);
    }

    let { fields } = this.state;
    for (var key in fields) {
      if (!fields[key].display && key !== "selectedOption") {
        fields[key].value = "";
      }
    }
    this.setState({ fields });

    if (fields.followup.display) {
      fields = this._updateOtherFieldsBasedOnFollowUp(fields);
      this.setState({ fields });
    } else {
      this._updateFieldsBasedOnDeliveryType(
        this.state.fields.deliveryMethod.value
      );
    }
  }

  _updateLanguageTranslationsForUserType = (userType, languageContent) => {
    if (languageContent.lang === "de") {
      if (userType === HCP) {
        /* eslint-disable spellcheck/spell-checker */
        languageContent.module.submitInquiry.requesterInformationTitle =
          "Ihre Daten";
        languageContent.formFieldRules.userType.title = "Fachkreis";
        /* eslint-enable spellcheck/spell-checker */
      } else if (userType === ABBVIE_EMPLOYEE) {
        /* eslint-disable spellcheck/spell-checker */
        languageContent.page.declaration =
          "Hiermit bestätige ich, dass der Anfragende, für den ich diese Medical-Information-Anfrag e übermittle, " +
          "Angehöriger der Medizinischen Fachkreise ist und diese Medical-Information-Anfrag e vollkommen unaufgefordert " +
          "an mich gestellt wurde. Ich bin mit der Verarbeitung meiner persönlichen " +
          "Daten gemäß der Datenschutzbestimmungen einverstanden.";
        /* eslint-enable spellcheck/spell-checker */
      }
    }
    return languageContent;
  };

  _responseWithinDropDownOptionsAsPerLanguage = (languageContent) => {
    const daysInLanguage = languageContent.module.submitInquiry.days;
    this.responseOptions = [
      {
        value: 2,
        label: "2 " + daysInLanguage,
      },
      {
        value: 5,
        label: "5 " + daysInLanguage,
      },
      {
        value: 7,
        label: "7 " + daysInLanguage,
      },
      {
        value: 15,
        label: "15 " + daysInLanguage,
      },
    ];
  };

  _setStateVariables(nextProps) {
    const countryList = nextProps.referenceCountries;
    const refData = nextProps.referenceData;
    const msgItems = nextProps.messageItems || [];

    if (msgItems.length > 0) {
      for (const msg of msgItems) {
        if (msg.siteMessageType.code === "MAINT" && msg.isDownTime) {
          this.setState({ maintMsg: true });
          break;
        }
      }
    }

    if (refData) {
      const { fields } = this.state;
      fields.country.value = refData.referenceData.SelectedCountry.name;
      fields.selectedOption.value = refData.referenceData.UserType;
      this.listOfCountries = countryList
        ? countryList.countries
        : this.listOfCountries;
      this.products = refData.referenceData.ProductMaster;
      this.indicatorOptions = refData.referenceData.indicators;
      this.medicalSpecialities = refData.referenceData.MedicalSpeciality;
      this.salutation = refData.referenceData.Salutation;
      this.requestorTypes = refData.referenceData.RequestorTypes;
      this.deliveryMethods = refData.referenceData.DeliveryMethods;
      this.productMasters = refData.referenceData.ProductMaster;

      /*
       * set product value for conference/scibooth flow based on passed product name
       * NOTE : This is one time initialization, therefore, the code is executed only once
       */
      if (this.queryParamProductName) {
        const selectedProduct = this.products.filter(
          (p) => p.name === this.queryParamProductName
        )[0];
        fields.product.value = selectedProduct.productCode;
        this.queryParamProductName = null;
      }
      fields.product.options = this.products.map((e) => e.productCode);
      fields.userType.options = this.requestorTypes.map((e) => e.requestor);
      fields.medicalSpeciality.options = this.medicalSpecialities.map(
        (e) => e.speciality
      );
      fields.title.options = this.salutation;
      fields.deliveryMethod.options = this.deliveryMethods.map(
        (e) => e.delivery
      );

      if (fields.question.value) {
        // Bug fix [20200729] - page crashes on reload
        if (nextProps.location && nextProps.location.state) {
          fields.question.value =
            nextProps.location.state.fields.question.value;
        }
      }

      // NOTE : Indicator valid options are set through callback upon selecting the product
      this.setState({
        fields,
        userCatagory: refData.referenceData.UserType,
        selectedCountry: refData.referenceData.SelectedCountry,
        loading: false,
      });
    }
  }

  _getQueryParamValue = (key) => {
    return decodeURIComponent(
      window.location.search.replace(
        new RegExp(
          "^(?:.*[&\\?]" +
            encodeURIComponent(key).replace(/[*+.]/g, "\\$&") +
            "(?:\\=([^&]*))?)?.*$",
          "i"
        ),
        "$1"
      )
    );
  };

  _setConferenceParams = (fields) => {
    var queryString = window.location.search;
    if (queryString !== "") {
      const params = new URLSearchParams(window.location.search);
      // let country = this._getQueryParamValue("country"); wondering if bug or intentional
      fields.conference.value = this._getQueryParamValue("conferencename");
      fields.firstname.value = this._getQueryParamValue("first");
      fields.lastname.value = this._getQueryParamValue("last");
      fields.email.value = this._getQueryParamValue("email");
      fields.phone.value = this._getQueryParamValue("phone");
      fields.street.value = this._getQueryParamValue("address");
      fields.city.value = this._getQueryParamValue("city");
      fields.state.value = this._getQueryParamValue("state");
      fields.postalCode.value = this._getQueryParamValue("zip");
      fields.affiliation.value = this._getQueryParamValue("institution");
      this.queryParamProductName = this._getQueryParamValue("product");
      fields.medicalSpeciality.value = this._getQueryParamValue("speciality");
      fields.userType.value = this._getQueryParamValue("requestor");
      fields.question.value = this._getQueryParamValue("question");
      fields.title.value = this._getQueryParamValue("title");
      fields.extn.value = this._getQueryParamValue("ext");
      fields.followup.value = !params.has("nofollowup");
      fields.deliveryMethod.value = fields.followup.value
        ? this._getQueryParamValue("deliver")
        : "";
      const respondedWith = this._getQueryParamValue("docs");
      fields.respondedWith.value = respondedWith
        ? JSON.parse(respondedWith)
        : [];
      fields = this._updateOtherFieldsBasedOnFollowUp(fields);
      const userCatagory = HCP;
      const callbackUrl = this._getQueryParamValue("callbackurl");

      /*
       * This is being called from constructor only, so mutate state directly instead of calling setState function
       */
      this.state.callbackUrl = callbackUrl;
      this.state.userCatagory = userCatagory;
      this.state.fields = fields;
    }
  };

  // If navigating from the details page, the product field should be autofilled with that product
  _setRouterFormState = (location, referenceData, fields) => {
    const routedState = location && location.state ? location.state : {};
    if (routedState.productId && referenceData) {
      const selectedProduct = referenceData.referenceData.ProductMaster.find(
        (p) => p.id === routedState.productId
      );
      if (selectedProduct) {
        fields.product.value = selectedProduct.productCode;
      }
    }
  };

  handleRequesterCountryChange = (country) => {
    // reset form data
    // this._reset();
    // reset redux store
    if (this.props.flowType === "SCIBOOTH" && country === "Italy") {
      this.setState({ showDocs: false, cart: [], docsLoading: false });
    }
    this.props.resetAction();
    this.props.CountryListAction(this.listOfCountries);
    var selectedCountry = this.listOfCountries.filter(function (item) {
      return item.name === country;
    });
    if (selectedCountry[0]) {
      this.setState({ loading: true });
      const selectedCountryValue = selectedCountry[0];
      const selectedUserType =
        StaticConfig.Context.UserType === ABBVIE_EMPLOYEE
          ? ABBVIE_EMPLOYEE
          : HCP;
      const selectedLanguage = this.props.pageContent.content.lang;
      const actionDispatchers = {
        selectedCountry: this.props.selectedCountryAction,
        referenceData: this.props.referenceDataAction,
        listOfCountries: this.props.listOfCountries,
        switchLanguage: this.props.switchLanguage,
        setPermissionAction: this.props.setPermissionAction,
      };
      document.cookie = `selectedEmployeeCountryLabel=${selectedCountryValue.name}`;
      const isConference = this.props.flowType !== "MI_PORTAL_REQUEST";
      initializeReferenceData(
        selectedCountryValue,
        selectedUserType,
        selectedLanguage,
        actionDispatchers,
        isConference
      );
    }
  };

  handleConsentChange = () => {
    const { fields } = this.state;
    fields.agree.value = !fields.agree.value;

    this.setState({ fields });
  };

  handleFollowupChange = (event) => {
    let { fields } = this.state;
    fields.followup.value = event.target.value === "Yes";
    fields = this._updateOtherFieldsBasedOnFollowUp(fields);
    this.setState({ fields });
  };

  _updateOtherFieldsBasedOnFollowUp = (fields) => {
    const followUp = fields.followup.value;
    fields.deliveryMethod.value = followUp ? fields.deliveryMethod.value : "";
    fields.deliveryMethod.rules.required.required = followUp;
    fields.deliveryMethod.disabled = !followUp;
    fields.deliveryMethod.rules.ignoreNull =
      !fields.deliveryMethod.rules.required.required;
    this._updateFieldsBasedOnDeliveryType(fields.deliveryMethod.value);
    this.checkIfRespondedWithRequired(fields, this.state.cart);
    return fields;
  };

  _validate(e, field) {
    if (typeof e.target.value === "string") {
      const inputValue = e.target.value.toLowerCase();
      const ref_Data = this.props.referenceData.referenceData;
      const regex = getApplicationRegex(ref_Data);
      if (regex.Emoji_Regex !== null && regex.Emoji_Regex.test(inputValue)) {
        // Emoji detected, prevent it from being added
        this._showNotification(
          "Error!",
          "Special characters are not allowed",
          "error"
        );
        return;
      } else if (regex.Script_Regex !== null && regex.Script_Regex.test(inputValue)) {
        // HTML Tags and Script detected, prevent it from being added
        this._showNotification(
          "Error!",
          "Submission fails. Input contains prohibited words. Please remove them and try again.",
          "error"
        );
        return;
      } else if (regex.Script_Regex === null || regex.Emoji_Regex === null) {
        this._showNotification(
          "Error!",
          "Validation configuration is missing. Please contact support.",
          "error"
        );
        return;
      }
    }
    const fields = validateField(e, field, this.state.fields);
    this.setState({ fields });
    return false;
  }

  // Resets the form Reset not clearing response options dropdown.
  _reset() {
    const { fields } = this.state;
    for (var key in fields) {
      if (key === "followup") {
        fields[key].value = true;
      } else if (!(key === "country" || key === "selectedOption")) {
        fields[key].value = "";
        fields[key].errors = [];
      }
    }
    this.requestInformationComponent._reset();
    this._updateFieldConfigurations(
      this.props.flowType,
      this.props.referenceData
    );
    this.setState({ fields, cart: [], showDocs: false });
  }

  _uploadedFiles(formData) {
    StaticConfig.Context.FileArray = formData;
    //  this.formData = formData;
  }

  getDocumentsForGMIS = (cart) => {
    return cart.map((number) => {
      return {
        number,
        name: this.state.documents.find((document) => {
          return document.number === number;
        }).name,
      };
    });
  };

  _submit(e) {
    this.setState({ loading: true });
    // collect and validate form fields first
    const fields = submitForm(e, this.state.fields);
    this.setState({ fields });

    // abort if validation errors
    for (var key in fields) {
      if (fields[key].errors.length > 0) {
        this.setState({ loading: false });
        return false;
      }
    }

    // build GMIS request using the validated fields
    const gmisRequest = buildGmisRequest(
      fields,
      this.state.selectedCountry,
      this.props.flowType
    );

    const submitHash = this.calculateHash(
      fields.email.value,
      gmisRequest.question
    );

    if (this.props.flowType === "SCIBOOTH") {
      gmisRequest.submitType = this.state.submitType;
      gmisRequest.documents = this.getDocumentsForGMIS(this.state.cart);
    }

    gmisRequest.submitHash = submitHash;

    try {
      this.formData = StaticConfig.Context.FileArray;
      this.formData.set("GMISRequest", JSON.stringify(gmisRequest));
    } catch (error) {
      this.formData = new FormData();
      this.formData.set("GMISRequest", JSON.stringify(gmisRequest));
    }
    this.formData.set("userCatagory", fields.selectedOption.value);
    const ref_Data = this.props.referenceData.referenceData;
    const SITE_KEY = getApplicationSiteKey(ref_Data);

    if (SITE_KEY) {
      // validation already performed above; proceed to execute reCAPTCHA
      window.grecaptcha.enterprise.ready(() => {
        window.grecaptcha.enterprise
          .execute(SITE_KEY, { action: "SUBMIT_INQUIRY" })
          .then((token) => {
            const queryParams = { token: token };
            api.submitGmisCase(
              queryParams,
              this.formData,
              this._submitGmisCaseSuccessHandler
            );
          })
          .catch(() => {
            this.props.notify({
              title: "Error!",
              message: "CAPTCHA verification failed. Please try again.",
              status: "error",
              position: "tr",
              dismissible: true,
              dismissAfter: 5000,
            });
            this.setState({ loading: false });
          });
      });
    } else {
      this.props.notify({
        title: "Error!",
        message: "CAPTCHA configuration is missing. Please contact support.",
        status: "error",
        position: "tr",
        dismissible: true,
        dismissAfter: 5000,
      });
      this.setState({ loading: false });
    }
  }

  _submitGmisCaseSuccessHandler = (res) => {
    const languageContent = this.props.pageContent.content;
    const { fields } = this.state;
    this.formData = new FormData();
    if (res.status === 200) {
      this._reset();
      this._showNotification(
        languageContent.success,
        languageContent.querySubmitMessage,
        "success"
      );
      if (this.props.flowType === "MI_PORTAL_REQUEST") {
        this.child._reset();
        StaticConfig.Context.FileArray = new FormData();
      } else {
        if (this.state.callbackUrl) {
          window.location.replace(this.state.callbackUrl);
        }
      }
    } else if (res.status === 401) {
      this._showNotification(
        languageContent.error,
        languageContent.errorSubmittingQuery,
        "error"
      );
      setTimeout(() => window.location.replace("/"), 3000);
    } else if (res.status === 503) {
      this.formData = new FormData();
      this.setState({ fields });
      res.text().then((data) => {
        const errorMessage =
          data.indexOf("upload") !== -1
            ? languageContent.errorUploadDocument
            : languageContent.errorCaseCreation;
        this._showNotification(languageContent.error, errorMessage, "error");
      });
    } else {
      this.formData = new FormData();
      this.setState({ fields });
      this._showNotification(
        languageContent.error,
        languageContent.errorSubmittingQuery,
        "error"
      );
    }

    this.setState({ loading: false });
    return res;
  };

  _showNotification = (title, message, status) => {
    const { notify } = this.props;
    notify({
      title,
      message,
      status,
      position: "tr",
      dismissible: true,
      dismissAfter: 3000,
    });
  };

  onToggle(node, toggled) {
    if (this.state.cursor) {
      this.state.cursor.active = false;
    }
    node.active = true;
    if (node.children) {
      node.toggled = toggled;
    }
    this.setState({ cursor: node });
  }

  handleProductChange = (validIndicationOptions, value) => {
    const { fields } = this.state;
    fields.indicator.value = "";
    fields.indicator.options = validIndicationOptions.map((i) => i.value);

    if (
      value === "NONP" &&
      (this.props.flowType === "CONFERENCE" ||
        this.props.flowType === "SCIBOOTH")
    ) {
      fields.indicator.value = "Not Specified";
    } else if (value === "NONP") {
      // NONP is Disease State
      fields.indicator.rules.required.required = true;
      fields.indicator.rules.ignoreNull = false;
    } else {
      fields.indicator.errors = [];
      fields.indicator.rules.required.required = false;
      fields.indicator.rules.ignoreNull = true;
    }
    this.setState({ fields });
  };

  calculateHash = (email, question) => {
    const challengeString = email + question;
    let nonce = 0;
    let hash = sha256(challengeString + nonce);
    while (hash.toString().substring(0, 4) !== "0000") {
      nonce += 1;
      hash = sha256(challengeString + nonce);
    }
    return nonce + ":" + hash;
  };

  setKioskSubmitType = (submitType) => {
    this.setState({ submitType });
  };

  render() {
    let languageContent = this.props.pageContent.content;
    languageContent = this._updateLanguageTranslationsForUserType(
      this.state.userCatagory,
      languageContent
    );

    const submitInquiryTranslations = languageContent.module.submitInquiry;
    const requestorTitle =
      this.state.userCatagory === PATIENT
        ? submitInquiryTranslations.requesterInformationPatientTitle
        : submitInquiryTranslations.requesterInformationTitle;

    this.countryList = this.listOfCountries.map(function (country) {
      return {
        value: country.name,
        label: country.name,
      };
    });

    const userCountry = getCookie("welcomeCountryCode");
    const selectedCountryValue = this.state.fields.country.value;
    if (!selectedCountryValue) {
      return (
        <SubmitInquiryLoading
          languageContent={languageContent}
          flowType={this.props.flowType}
        />
      );
    } else {
      const jsx = (
        <div>
          {this.props.embedded !== "true" && (
            <HeroImage
              title={
                StaticConfig.Context.UserType === PATIENT
                  ? submitInquiryTranslations.patientTitle
                  : submitInquiryTranslations.title
              }
              imageMobile={imgHeaderSubmitInquiryMobile}
              imageDesktop={imgHeaderSubmitInquiry}
            />
          )}
          <div className="container">
            <div id="mail-submit-query" className="widget-mb-0-row">
              <form
                onKeyPress={(e) => {
                  if (
                    this.props.flowType === "SCIBOOTH" &&
                    e.which === 13 &&
                    e.target.type !== "textarea"
                  ) {
                    e.preventDefault();
                  }
                }}
                onSubmit={(e) => {
                  e.preventDefault();
                  this._submit(e);
                }}
              >
                <div>
                  <div className="row">
                    <div className="col-12 col-xl-12">
                      {this.props.embedded === "true" ? (
                        <h3 className="mb-3 header-primary">
                          {submitInquiryTranslations.title}
                        </h3>
                      ) : null}
                      <div className="row submit-inquiry-subtitle">
                        <div className="col-xl-10 col-sm-8">
                          {this.props.flowType === "MI_PORTAL_REQUEST" ? (
                            <p className="text-left">
                              {StaticConfig.Context.UserType === PATIENT &&
                                userCountry !== "DE" && (
                                  <React.Fragment>
                                    {submitInquiryTranslations.patientSubTitle}
                                    <a
                                      href="tel:8446633742"
                                      className="anchor-link"
                                    >
                                      844-663-3742
                                    </a>
                                    .
                                  </React.Fragment>
                                )}
                              {StaticConfig.Context.UserType === PATIENT &&
                                userCountry == "DE" && (
                                  <React.Fragment>
                                    {submitInquiryTranslations.patientSubTitle}
                                    <a
                                      href="tel:0611-1720 1520"
                                      className="anchor-link"
                                    >
                                      0611-1720 1520
                                    </a>
                                    .
                                  </React.Fragment>
                                )}
                              {StaticConfig.Context.UserType ===
                                ABBVIE_EMPLOYEE && (
                                <React.Fragment>
                                  {submitInquiryTranslations.subTitle}
                                  <br></br>
                                  <div className="employee-subtitle">
                                    {
                                      submitInquiryTranslations.employeeExtraSubtitle
                                    }
                                  </div>
                                </React.Fragment>
                              )}
                              {StaticConfig.Context.UserType !==
                                ABBVIE_EMPLOYEE &&
                                StaticConfig.Context.UserType !== PATIENT && (
                                  <React.Fragment>
                                    {submitInquiryTranslations.subTitle}
                                  </React.Fragment>
                                )}
                            </p>
                          ) : null}
                        </div>
                        <div className="col-xl-2 col-sm-4">
                          <p className="text-right">
                            <strong>
                              *{submitInquiryTranslations.required}
                            </strong>
                          </p>
                        </div>
                      </div>
                      {StaticConfig.Context.UserType === PATIENT && (
                        <Widget
                          title={submitInquiryTranslations.contactPreference}
                        >
                          <PatientDeliveryMethod
                            fields={this.state.fields}
                            validate={this._validate}
                            deliveryMethods={this.deliveryMethods}
                            updateValidationField={
                              this._updatePatientFieldsBasedOnDeliveryType
                            }
                          />
                        </Widget>
                      )}
                      <div>
                        {StaticConfig.Context.Country.isGMISEnable ||
                        this.props.flowType === "SCIBOOTH" ||
                        this.props.flowType === "CONFERENCE" ? (
                          <Widget title={requestorTitle}>
                            <RequestorInformation
                              fields={this.state.fields}
                              validate={this._validate}
                              medicalSpecialities={this.medicalSpecialities}
                              flowType={this.props.flowType}
                              permissions={this.props.permissions}
                              salutation={this.salutation}
                              requestorTypes={this.requestorTypes}
                              language={languageContent.lang}
                            />
                          </Widget>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12 col-xl-12">
                      <Widget
                        title={
                          languageContent.module.submitInquiry
                            .requestInformationTitle
                        }
                      >
                        <RequestInformation
                          updateValidationField={
                            this._updateFieldsBasedOnDeliveryType
                          }
                          fields={this.state.fields}
                          validate={this._validate}
                          indicators={this.indicatorOptions}
                          countries={this.listOfCountries}
                          flowType={this.props.flowType}
                          onRequesterCountryChange={
                            this.handleRequesterCountryChange
                          }
                          deliveryMethods={this.deliveryMethods}
                          conferenceOptions={this.conferenceOptions}
                          documents={this.state.documents}
                          cart={this.state.cart}
                          lang={this.props.pageContent.content}
                          onFollowupChange={this.handleFollowupChange}
                          productMasters={this.productMasters}
                          products={this.products}
                          ref={(cd) => (this.requestInformationComponent = cd)}
                          responseOptions={this.responseOptions}
                          showDocs={this.state.showDocs}
                          onProductChange={this.handleProductChange}
                          onConferenceChange={this.handleConferenceChange}
                          onAttachDocsRadio={this.handleAttachDocsRadio}
                          onCart={this.handleCart}
                          permissions={this.props.permissions}
                          loading={this.state.docsLoading}
                        />
                      </Widget>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12 col-xl-12 widget-mb-0-row">
                      <Widget>
                        <CertifyDocuments
                          ref={(cd) => (this.child = cd)}
                          flowType={this.props.flowType}
                          loading={this.state.loading}
                          field={this.state.fields.agree}
                          languageContent={languageContent}
                          _uploadedFiles={this._uploadedFiles}
                          reset={this._reset}
                          onConsentChange={this.handleConsentChange}
                          setKioskSubmitType={this.setKioskSubmitType}
                          disableSend={this.state.cart.length === 0}
                          maintMsg={this.state.maintMsg}
                        />
                      </Widget>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      );
      return this.countriesMatched() ? jsx : null;
    }
  }
}

function mapStateToProps(state) {
  return {
    referenceData: state.referenceData.find(
      (category) => category.type === REF_DATA
    ),
    referenceCountries: state.referenceData.find(
      (category) => category.type === COUNTRIES
    ),
    pageContent: state.pageContent,
    permissions: state.permissions,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      selectedCountryAction: selectedCountry,
      referenceDataAction: referenceData,
      CountryListAction: listOfCountries,
      notify: notify,
      resetAction: reset,
      switchLanguage,
      setPermissionAction,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(SubmitInquiry);



// WEBPACK FOOTER //
// ./src/mi-app/submitInquiry/SubmitInquiry.js